import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Color } from 'swag-client-common/components/ui/color';
import { SinglePantonePicker } from '../single-pantone-picker';
import classes from './pantone-color-picker.scss';
export function PantoneColorPicker({
  colors,
  exactPantones = undefined,
  selected,
  isConvertingMode,
  onColorClick,
  showHint = true
}) {
  const isActionable = !!onColorClick;
  const selectedPms = selected && selected.pms;
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.colorsRow, {
      [classes.blurred]: exactPantones,
      [classes.leftAligned]: isConvertingMode
    })
  }, colors.map((pantoneColor, index) => /*#__PURE__*/React.createElement("div", {
    key: index,
    className: classes.colorColumn
  }, /*#__PURE__*/React.createElement(Color, {
    isActive: selectedPms === pantoneColor.pms,
    isActionable: isActionable,
    color: pantoneColor.hex,
    onClick: () => {
      if (isActionable) {
        onColorClick(pantoneColor);
      }
    }
  }), /*#__PURE__*/React.createElement("span", null, pantoneColor.pms)))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(SinglePantonePicker, {
    initialPantone: selectedPms === 'exact' ? selected.pms : '',
    onSubmit: onColorClick,
    shouldValidatePantone: true
  })), showHint && /*#__PURE__*/React.createElement("div", {
    className: classes.description
  }, "You can also do this later and input exact color", isConvertingMode ? '' : 's', ' ', "after you place your order.\xA0", !isConvertingMode && 'We are going to make sure your design comes out exactly how you want.'));
}
PantoneColorPicker.propTypes = {
  onColorClick: PropTypes.func,
  colors: PropTypes.array.isRequired,
  onExactPantonesChange: PropTypes.func.isRequired
};
PantoneColorPicker.defaultProps = {
  colors: []
};